import React, { useEffect } from "react"
import { useLocation } from 'react-router-dom';
import ErrorX from '../../../../assets/images/payments/xmark-solid.svg'
import CheckMark from '../../../../assets/images/payments/check-solid.svg'
import { paymentPurchase } from "../../../misc/apiRequests";

const PaymentCompletion = ({ user, setRedirect, handleMessagesModal, handleLoader }) => {
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  const query = useQuery();

  const status = query.get('STATUS');
  const success = status === 'PAID';
  const orderNumber = query.get('ORDER_NUMBER');
  const amount = query.get('AMOUNT');
  const paymentId = query.get('PAYMENT_ID');
  const paymentPlatform = query.get('PAYMENT_PLATFORM');
  const timestamp = query.get('TIMESTAMP');

  useEffect(() => {
    // Handle Subscription plan payment
    const handlePaymentCompletion = () => {
      handleLoader(true);
      paymentPurchase({
        order_number: orderNumber,
        amount,
        payment_id: paymentId,
        payment_platform: paymentPlatform,
        timestamp
      })
        .then(response => {
          if (response.success) {
            handleMessagesModal('Payment was successful', response.message, 'success');
            setRedirect('/account?page=payment');
          }
          if (!response.success) {
            handleMessagesModal('Submission Issue', Array.isArray(response.errors) ? response.errors.join("\n") : response.errors, 'error');
          }
          handleLoader(false);
        });
    }

    if (success && paymentId) { handlePaymentCompletion(); }
  }, [success, paymentId, orderNumber, amount, paymentPlatform, timestamp, handleLoader, handleMessagesModal, setRedirect])

  const unsuccessfulRender = () => (
    <div className="container-md">
      <div className="text-center">
        <div className="mb-4">
          <button className="btn btn-danger rounded-circle" style={{width: '110px', height: '110px'}}>
            <img src={ErrorX} className="w-50" style={{ filter: 'invert(1)' }} alt="error"/>
          </button>
        </div>
        <p className="text-danger fw-bold fs-2">Your payment was not completed</p>
        <p className="fs-4">Your payment was cancelled or could not be processed. You can close this window and try again.</p>
      </div>
      {/* <div className="d-flex flex-row justify-content-center">
        <button className="btn btn-primary fs-4 mt-4" onClick={() => setRedirect('/account?page=payment')}>Okay, I Understand</button>
      </div> */}
    </div>
  )

  const successfulRender = () => (
    <div className="container-md">
      <div className="text-center">
        <div className="mb-4">
          <button className="btn btn-success rounded-circle" style={{width: '110px', height: '110px'}}>
            <img src={CheckMark} className="w-50" style={{ filter: 'invert(1)' }} alt="success"/>
          </button>
        </div>
        <p className="text-success fw-bold fs-2">Your payment was processed successfully</p>
        <p className="fs-4">Thank you for your purchase.</p>
      </div>
      {/* <div className="d-flex flex-row justify-content-center">
        <button className="btn btn-primary fs-4 mt-4" onClick={() => setRedirect('/account?page=payment')}>Okay, I Understand</button>
      </div> */}
    </div>
  )

  return success ? successfulRender() : unsuccessfulRender()
}

export default PaymentCompletion
